"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("@osmosys/utils");
const BlueprintTemplateParser_1 = require("../../paser/BlueprintTemplateParser");
exports.repeatBlock = (repeatOf) => {
    if (!repeatOf.originalHtml) {
        utils_1.logger.error('repeatBlock | No original HTML found.');
        return;
    }
    const newBlocks = new BlueprintTemplateParser_1.BlueprintTemplateParser().parseHtmlPartialString(repeatOf.originalHtml);
    if (!newBlocks || newBlocks.length === 0) {
        utils_1.logger.error('repeatBlock | No block parsed.');
        return;
    }
    return newBlocks[0];
    // const newBlock = { ...repeatOf };
    // delete newBlock.clientId;
    // delete newBlock.id;
    // delete newBlock.parentBlock;
    // delete newBlock.instanceOf;
    // delete newBlock.instances;
    // delete newBlock.isInstance;
    // delete newBlock.repeatParentBlock;
    // newBlock.childBlocks = !newBlock.childBlocks
    //   ? []
    //   : newBlock.childBlocks.map(b => {
    //       return repeatBlock(b);
    //     });
    // newBlock.repeatChildBlocks = [];
    // newBlock.repeatInstances = [];
    // newBlock.instances = [];
    // newBlock.repeatOf = repeatOf;
    // newBlock.clientId = generateId();
    // newBlock.parsedHtml = newBlock.parsedHtml
    //   ? replaceAll(newBlock.parsedHtml, `${repeatOf.clientId}`, newBlock.clientId)
    //   : '';
    // return newBlock;
};
//# sourceMappingURL=repeatBlock.js.map